<template>
  <sw-application id="app">
    <top-bar :editor="pixelEditor" @closePixel='closeModalOpen = true'/>
    <div class="application__content flex center">
      <div
        class="flex center"
        ref="container"
        @drop.prevent.stop="drop_handler"
        @dragover.prevent.stop="drop_handler"
      ></div>
    </div>
    <div class="application__menu flex center" ref="menu">
      <div class="menu-wrapper flex center">
        <transition name="fade" mode="out-in">
            <component
              :is="currentMenu"
              :editor="pixelEditor"
              @changeMenu="nextMenu"
              @backMenu="backMenu"
              @openImage="openImage"
              @openEmoji="openEmoji"
            />
        </transition>
      </div>
    </div>
    <image-modal :open="imageModalOpen" @close="imageModalOpen = false" :editor="pixelEditor" />
    <emoji-modal :open="emojiModalOpen" @close="emojiModalOpen = false" :editor="pixelEditor" />
    <template-info @createTemplate="createTemplateHandler" />
    <template-save-modal :editor="pixelEditor" @changeMenu="nextMenu" />
    <template-load-modal :open="templateLoading" @changeMenu="nextMenu" />
    <template-delete-modal :open="templateDeleteting" @close="templateDeleteting = false" :template="template" />
    <payment-modal />
    <close-modal :open="closeModalOpen" @close="closeModalOpen = false" @closePixel='sendClosePixel'/>
    <banner-info />
  </sw-application>
</template>
<script>
import BannerInfo from '@/components/infos/BannerInfo'
import TopBar from '@/components/top/TopBar'
import PixelEditor from '@/model/pixel/PixelEditor'
import { mapActions, mapGetters } from 'vuex'
//----------------- MENU
import DefaultMenu from '@/components/menu/DefaultMenu'

import FormatMenu from '@/components/menu/format/FormatMenu'
import PersonnalFormat from '@/components/menu/format/PersonnalFormat'

import CalquesMenu from '@/components/menu/CalquesMenu'
import FiltresMenu from '@/components/menu/FiltresMenu'

import AjustementsMenu from '@/components/menu/AjustementsMenu'
import LuminositeMenu from '@/components/menu/ajustement/LuminositeMenu'

import FormesMenu from '@/components/menu/FormesMenu'
import TextMenu from '@/components/menu/TextMenu'

import EmojiModal from '@/components/modal/EmojiModal'
import ImageModal from '@/components/modal/ImageModal'
import KeyBoardManager from '@/model/pixel/elements/KeyBoardManager'

import TemplatesMenu from '@/components/menu/TemplatesMenu'
import CreateTemplateMenu from '@/components/menu/template/CreateTemplateMenu'
import TemplateInfo from '@/components/menu/template/TemplateInfo'
import TemplateDeleteModal from '@/components/modal/TemplateDeleteModal'
import TemplateLoadModal from '@/components/modal/TemplateLoadModal'
import TemplateSaveModal from '@/components/modal/TemplateSaveModal'

import CloseModal from '@/components/modal/CloseModal'
import PaymentModal from '@/components/modal/PaymentModal'

import { EventBus, PAYMENT_INFO, TEMPLATE_DELETING, TEMPLATE_LOADING, TEMPLATE_MODIFIED } from '@/model/EventBus'

import { defined, getLast, gt } from 'junctions-fp'
import HttpConnector from './model/http/HttpConnector'

import WebFont from 'webfontloader'

import { closePixel, pixelReady } from '@/model/PixelIOGateway'

export default {
  name: 'app',
  components: {
    ImageModal,
    EmojiModal,
    TopBar,
    BannerInfo,
    DefaultMenu,
    FormatMenu,
    PersonnalFormat,
    CalquesMenu,
    TemplatesMenu,
    FiltresMenu,
    AjustementsMenu,
    LuminositeMenu,
    TextMenu,
    FormesMenu,
    TemplateInfo,
    CreateTemplateMenu,
    TemplateSaveModal,
    TemplateLoadModal,
    TemplateDeleteModal,
    PaymentModal,
    CloseModal
  },
  created() {
    const uri = new URL(window.location)

    let token = uri.searchParams.get('t')
    if(token){
      HttpConnector.getInstance(token)
    }else{
      let domain= uri.searchParams.get('d')
      if(domain && domain.trim()=== "*" ){
        throw new Error('domain error')
      }
      this.updateDomain(domain)
    }

    //pixel io connector
    window.addEventListener('message', async event => {
      const message = event.data
      if (message.event === 'init' && message.emitter === 'pixelio') {
        if (message.image) {
          this.pixelEditor.loadImage(message.image)
        }
        if(!token){
          HttpConnector.getInstance(message.token)
          await this.getUserInfo()
          await this.loadFonts()
          if(uri.searchParams.get('d')!== this.getDomain){
            console.error(`domain in url param ${uri.searchParams.get('d')} not same url in plan ${this.getDomain}`)
          }
        }
        if(defined(message.size)){
          this.pixelEditor.changeFormat(message.size.width, message.size.height)
          const f = {
            format: 'publication',
            width: message.size.width,
            height: message.size.height,
            network: 'personnal',
            font: 'fa',
            icon: 'user',
            label: 'personnal'
          }
          this.updateRestrictedSize(message.size.restrict || false)
          this.updateCurrentFormat(f)
        }
        this.updateOpenedMode(message.openedMode)
        this.updateSaveLocal(message.canSaveLocal)
        this.updateUpgradeEvent(message.upgradeEvent)
        this.updateCloseButton(message.closeButton)
        this.updateSaveMenuList(message.saveMenuList)
      }
    })

    //
    this.pixelEditor = new PixelEditor()
    this.pixelEditor.on('imageLoaded', () => EventBus.$emit(TEMPLATE_MODIFIED))
    this.pixelEditor.on('zoomUpadted', zoomValue => (this.zoomFactor = Math.floor(zoomValue * 100)))
    this.pixelEditor.on('removeItem', () => EventBus.$emit(TEMPLATE_MODIFIED))
    this.pixelEditor.on('modified', evt => EventBus.$emit(TEMPLATE_MODIFIED))
    this.pixelEditor.on('loadedTemplate', evt => (this.templateLoading = false))
    this.pixelEditor.on(KeyBoardManager.EVENT_CREATE_TEXTBOX, evt => this.createText())
    this.pixelEditor.on(KeyBoardManager.EVENT_SHOW_FILTER, evt => this.onSelectFilter())
    this.pixelEditor.on(KeyBoardManager.EVENT_SHOW_IMAGE, evt => this.openImage())
    this.pixelEditor.on(KeyBoardManager.EVENT_SHOW_ADJUSTEMENT, evt => this.nextMenu('AjustementsMenu'))
    this.pixelEditor.on(KeyBoardManager.EVENT_SHOW_SHAPE, evt => this.nextMenu('FormesMenu'))
    this.pixelEditor.on(KeyBoardManager.EVENT_SHOW_TEMPLATE, evt => this.nextMenu('TemplatesMenu'))
    this.pixelEditor.on(KeyBoardManager.EVENT_SHOW_LAYER, evt => this.nextMenu('CalquesMenu'))
    EventBus.$on(TEMPLATE_LOADING, () => (this.templateLoading = true))
    EventBus.$on(TEMPLATE_DELETING, (template) =>{
      this.template = template
      this.templateDeleteting = true
    })
  },
  async mounted() {
    console.log(`%c🪻 Swello Pixel v1.6.2.b 🪻`, 'font-size:1rem;color:#9B3196;')
    this.pixelEditor.setContainer(this.$refs.container, this.getEditorMaxSize.maxWidth, this.getEditorMaxSize.maxHeight)
    this.resizeEditor()
    window.addEventListener('resize', this.resizeEditor)
    try {
      const uri = new URL(window.location)
      if(uri.searchParams.get('t')){
        await this.getUserInfo()
        await this.loadFonts()
      }

      pixelReady(this.getDomain)
    } catch (e) {
      console.log(e)
      console.log('error')
    }
  },
  data() {
    return {
      historyMenu: ['DefaultMenu'],
      imageModalOpen: false,
      emojiModalOpen: false,
      pixelEditor: null,
      openStartModal: true,
      openExportModal: false,
      openLoadingModal: false,
      templateLoading: false,
      templateDeleteting:false,
      template:null,
      showPayment: false,
      loadingModalLabel: 'Chargement en cours...',
      uploadFilesLength: 1,
      currentUploadedFiles: 0,
      currentFormat: null,
      zoomFactor: 50,
      showLoader: false,
      showSaveModal: false,
      formatList: [],
      closeModalOpen:false,
      editorSize: {
        maxHeight: '0px',
        textAlign: 'center'
      }
    }
  },
  computed: {
    ...mapGetters([
    'getFormatButtons', 
    'getCurrentFormat', 
    'getCurrentColor', 
    'getFontFormat', 
    'templatesList', 
    'getLimitations', 
    'getFontsList', 
    'getEditorMaxSize',
    'getDomain'
    ]),
    currentMenu() {
      return getLast(this.historyMenu)
    }
  },
  methods: {
    ...mapActions([
      'getTemplate',
      'saveTemplate',
      'deleteTemplate',
      'updateTemplate',
      'getUserInfo',
      'updateCurrentFormat',
      'updateSaveLocal',
      'updateOpenedMode',
      'updateRestrictedSize',
      'updateUpgradeEvent',
      'updateDomain',
      'updateCloseButton',
      'updateSaveMenuList'
    ]),
    async loadFonts(){
      if(this.getFontsList && this.getFontsList.length > 0){
        WebFont.load({
          google: {
            families: this.getFontsList.filter(f => f.type === 'google').map(f=>f.cssUrl)
          },
          custom:{
            families: this.getFontsList.filter(f => f.type === 'custom').map(f=> (f.fontFamily ? f.fontFamily : f.label)),
            urls: this.getFontsList.filter(f => f.type === 'custom').map(f=>f.cssUrl),
          }
        })
      }
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // MENU
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    nextMenu(menu) {
      if (getLast(this.historyMenu) !== menu) this.historyMenu = [...this.historyMenu, menu]
    },
    backMenu() {
      this.historyMenu.splice(-1, 1)
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // SHORTCUT HANDLER
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    openImage() {
      this.imageModalOpen = true
    },
    openEmoji() {
      this.emojiModalOpen = true
    },

    createText() {
      this.pixelEditor.insertText({width: 200, fill: '#000', lineHeight: 1.16,...this.getFontFormat })
      this.nextMenu('TextMenu')
      EventBus.$emit(TEMPLATE_MODIFIED)
    },

    onSelectFilter(item) {
      this.nextMenu('FiltresMenu')
    },

    createTemplateHandler() {
      this.nextMenu('CreateTemplateMenu')
    },

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // GLOBAL
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    resizeEditor() {
      const mh = this.$refs.menu ? window.innerHeight - this.$refs.menu.scrollHeight : 0
      this.editorSize = {
        height: mh + 'px'
      }
    },

    loadedTemplate(item){

    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DRAG AND DROP
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    onFileUpload(image) {
      this.pixelEditor.loadImage(image)
    },
    drop_handler(evt) {
      if (evt.type === 'drop') {
        const dt = evt.dataTransfer
        if (dt.items) {
          const items = [...dt.items]
          if (this.getLimitations.maxImages !== -1 && gt(this.getLimitations.maxImages, this.pixelEditor.getImagesCount() + items.length)) {
            EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
            return
          }
          items.forEach(element => {
            this.onFileUpload(element.getAsFile())
          })
          EventBus.$emit(TEMPLATE_MODIFIED)
        }
      }
    },
    handler(evt) {},
    sendClosePixel(){
      this.closeModalOpen = false
    closePixel(this.getDomain)

    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/App.vue